import { SPD } from '@/apis/search'

export enum MarketType {
  'ZSP' = 0,
  'ZDK' = 1,
}

// 网商园
export enum WsyPlatformTypeEnum {
  /** 热卖商品 */
  'WS-RMSP'='WS-RMSP',
   /** 今日新品 */
  'WS-JRXP'='WS-JRXP',
  /** 每周爆款-七日爆款 */
  'WS-QRBK'='WS-QRBK',
  /** 每周爆款-热销榜单 */
  'WS-RXBD'='WS-RXBD',
  /** 每周爆款-行业新品 */
  'WS-HYXP'='WS-HYXP'
}

// VVIC 搜款网
export enum VvicPlatformTypeEnum {
   /** 商品榜（不需要） */
   'VC-SPB'='VC-SPB',
  /** 每日新品 */
  'VC-MRXP'='VC-MRXP',
   /** 七日热款 */
  'VC-QRRK'='VC-QRRK',
  /** 现货专区 */
  'VC-XHZQ'='VC-XHZQ',
}

// 平台类型;TB:淘宝;AM:1688;TM:天猫;VC:搜款网;WS:网商园
export enum PlatformTypeEnum {
  TB='TB',
  AM='AM',
  TM='TM',
  // 搜款网
  VC='VC',
  // 网商园
  WS='WS'
}

export interface ModelValProps extends SPD{
  tabs?: string
  navTab?: MarketType
}

export interface WSYModelValProps extends ModelValProps{
  areaCodes?:WsyPlatformTypeEnum;
  areaCodes2?:WsyPlatformTypeEnum;

}

export interface VVICmodelvalprops extends ModelValProps{
  areaCodes?:VvicPlatformTypeEnum;
  cateCode?:string
}
